module.exports = __webpack_public_path__ + "static/media/01_propose_a.b0251d6b.mp4";